import { render, staticRenderFns } from "./HeaderSwiper.vue?vue&type=template&id=82aadea2&"
import script from "./HeaderSwiper.vue?vue&type=script&lang=js&"
export * from "./HeaderSwiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports